const routes = [
  {
    path: '/',
    component: () => import('src/layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('src/pages/IndexPage.vue')
      },
      {
        path: 'pair-device',
        name: 'pair-device',
        component: () => import('src/pages/PairDevice.vue')
      },
      {
        path: 'screen',
        name: 'screen',
        component: () => import('src/pages/BlueScreen.vue')
      },
      {
        path: 'monitor',
        name: 'monitor',
        component: () => import('src/pages/MonitorPage.vue')
      },
    ]
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue')
  }
]

export default routes
